export const standardTaxCodes = [
  { name: '(0) -  No VAT treatment', id: 0 },
  { name: '(1) -  Input VAT deductible (domestic) - Regular rate', id: 1 },
  { name: '(11) - Input VAT deductible (domestic) - Reduced rate, middle', id: 11 },
  { name: '(12) - Input VAT deductible (domestic) - Reduced rate, raw fish', id: 12 },
  { name: '(13) - Input VAT deductible (domestic) - Reduced rate, low', id: 13 },
  { name: '(14) - Input VAT deductible (paid on import) - Regular rate', id: 14 },
  { name: '(15) - Input VAT deductible (paid on import) - Reduced rate, middle', id: 15 },
  { name: '(20) - Basis on import of goods - No VAT treatment', id: 20 },
  { name: '(21) - Basis on import of goods - Regular rate', id: 21 },
  { name: '(22) - Basis on import of goods - Reduced rate, middle', id: 22 },
  { name: '(3) -  Output VAT - Regular rate', id: 3 },
  { name: '(31) - Output VAT - Reduced rate, middle', id: 31 },
  { name: '(32) - Output VAT - Reduced rate, raw fish', id: 32 },
  { name: '(33) - Output VAT - Reduced rate, low', id: 33 },
  { name: '(5) -  No output VAT - Zero rate', id: 5 },
  { name: '(51) - Domestic sales of reverse charge/VAT obligation - Zero rate', id: 51 },
  { name: '(52) - Export of goods and services - Zero rate', id: 52 },
  { name: '(6) -  Not liable to VAT treatment, turnover outside the scope of the VAT legislation', id: 6 },
  { name: '(7) -  No VAT treatment - no turnover according to the VAT legislation', id: 7 },
  { name: '(81) - Importation of goods, VAT deductible - Regular rate', id: 81 },
  { name: '(82) - Importation of goods, without deduction of VAT - Regular rate', id: 82 },
  { name: '(83) - Importation of goods, VAT deductible - Reduced rate, middle', id: 83 },
  { name: '(84) - Importation of goods, without deduction of VAT - Reduced rate, middle', id: 84 },
  { name: '(85) - Importation of goods, not applicable for VAT - Zero rate', id: 85 },
  { name: '(86) - Services purchased from abroad, VAT deductible - Regular rate', id: 86 },
  { name: '(87) - Services purchased from abroad, without deduction of VAT - Regular rate', id: 87 },
  { name: '(88) - Services purchased from abroad, VAT deductible - Reduced rate, low', id: 88 },
  { name: '(89) - Services purchased from abroad, without deduction of VAT - Reduced rate, low', id: 89 },
  { name: '(91) - Purchase of emissions trading or gold, VAT deductible - Regular rate', id: 91 },
  { name: '(92) - Purchase of emissions trading or gold, without deduction of VAT - Regular rate', id: 92 },
];
